import { createContext, useState, useEffect } from 'react';
import { useSites } from '../../hooks/useSites';

const SiteContext = createContext({
    sitesAssignedToUser: undefined,
    selectedSite: undefined,
    setSelectedSite: () => { }
});

const SiteProvider = ({ children }) => {

    const { sitesAssignedToUser } = useSites();
    const [selectedSite, setSelectedSite] = useState();

    useEffect(() => {
        if (sitesAssignedToUser && sitesAssignedToUser.length > 0) {
            setSelectedSite(sitesAssignedToUser[0].id);
        } else {
            console.log("User has no assigned sites");
        }
    }, [sitesAssignedToUser])

    return (
        <SiteContext.Provider value={{ sitesAssignedToUser, selectedSite, setSelectedSite }}>
            {children}
        </SiteContext.Provider>
    );
};

export { SiteContext, SiteProvider };